// extracted by mini-css-extract-plugin
module.exports = {"navBarTeam":"styles_navBarTeam__1tee4","infoChatbot":"styles_infoChatbot__19ePa","companiesContainer":"styles_companiesContainer__1-Bz5"};